<!--专业成长-->
<template>
    <div class="studio_nav_content">
        <div class="page-mode">
            <div class="sec-title">
                <div class="bar"></div>
                <div class="name">专业成长</div>
            </div>
            <div class="honor-body">
                <div class="honor-list">
                    <div class="honor-item" v-for="item in 9" :key="item">
                        <img class="honor-img" :src="require(`../../assets/rycj/${isLit(item) ? 'ry' : 'ryh'}-${item}.png`)" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userCenterInfo } from "@/api/admin/public";

export default {
    name: "myHonors",
    components: {},
    data() {
        return {
            honorList: [],
        };
    },
    created() {
        this.getUserCenterInfo();
    },
    methods: {
        isLit(item) {
            return this.honorList.indexOf(String(item)) > -1;
        },
        getUserCenterInfo() {
            userCenterInfo().then(res => {
                let honor = res.data.data.honor;
                if (honor) {
                    this.honorList = honor.split(',')
                    if (this.honorList[this.honorList.length - 1] == '') {
                        this.honorList.splice(this.honorList.length - 1, 1)
                    }
                } else {
                    this.honorList = [];
                }
            })
        },
    }
};
</script>
<style scoped>
.studio_nav_content{
    width: 100%;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 24px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}
/*区块标题*/
.sec-title{
    display: flex;
    align-items: center;
    height: 30px;
    margin-bottom: 16px;
    .bar{
        width: 4px;
        height: 16px;
        background: #0d55a4;
        border-radius: 2px;
        margin-right: 8px;
    }
    .name{
        font-size: 16px;
        font-weight: bold;
        color: #333;
    }
}
/*荣誉徽章*/
.honor-body{
    flex: 1;
    min-height: 0;
}
.honor-list{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    width: calc(100% * 2 / 3);
    height: 100%;
    margin: 0 auto;
}
.honor-item{
    width: calc((100% - 32px) / 3);
    height: calc((100% - 32px) / 3);
    padding: 12px;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
.honor-img{
    max-width: 60%;
    max-height: 90%;
    display: block;
    margin: 0 auto;
}
</style>
